export default __webpack_public_path__ + "static/media/gallery-wip-handle_05.8d6e01b7.jpg";